module.exports = __webpack_public_path__ + "static/media/fedpa-noneOption.c4565c2f.svg";